import React from 'react';

export const generateAvatar = (firstName ='', lastName = '') => (
    <div className="avatar">
        {`${firstName.substr(0, 1).toUpperCase()}${lastName.substr(0, 1).toUpperCase()}`}
    </div>
);